import { Box, Stack } from "@mui/system";
import BLDWebsiteUserCard from "./BLDWebsiteUserCard";
import {
  formatCurrency,
  formatDate,
  formatNumber,
  formatPercent,
} from "../../../../../helpers/roundFunctions";
import { spacing } from "../../../../../../../../../../assets/styles/tokens";

const BLDWebsiteUser = ({ sortedData }: any) => {
  const getCvrColor = (cvr: number) => {
    if (cvr < 0.07) return "error";
    if (cvr > 0.3) return "success";
    return "warning";
  };
  const getFtdColor = (value: number) => {
    if (value < 0.85) return "error";
    if (value > 0.95) return "success";
    return "warning";
  };
  return (
    <>
      <Box sx={{ mt: "-" + spacing.Spacing.md.$value }}>
        <Stack spacing={2}>
          {sortedData?.map((item: any, index: number) => (
            <BLDWebsiteUserCard
              key={index}
              date={formatDate(item.start_of_week || item.date || item.month)}
              Spent={formatCurrency(item.spend)}
              cpc={formatCurrency(item.cpc)}
              clickOut={formatNumber(item.click_out)}
              ClickIn={formatNumber(item.click_in)}
              ftdBR={formatNumber(item.br_ftd)}
              ftdNG={formatNumber(item.ng_ftd)}
              ftdPercentage={formatPercent(item.ng_ftd_br_ftd)}
              ftdColor={getFtdColor(item.ng_ftd_br_ftd)}
              cvrPercentage={formatPercent(item.cvr)}
              cvrColor={getCvrColor(item.cvr)}
              qftd={formatNumber(item.qftds)}
            />
          ))}
        </Stack>
      </Box>
    </>
  );
};

export default BLDWebsiteUser;
